import { i18n } from "@/boot/i18n";

export const TICKET_TYPE = {
  PROBLEM: 1,
  INCIDENT: 2,
  DOUBT: 3,
  TASK: 4
};

export const TICKET_PRIORITY = {
  URGENT: 1,
  HIGH: 2,
  NORMAL: 3,
  LOW: 4
};

export const TICKET_STATUS = {
  OPEN: 1,
  PENDING: 2,
  WAITING: 3,
  SOLVED: 4,
  CLOSED: 5
};

export const TICKET_TYPE_OPTIONS = [
  {
    value: TICKET_TYPE.PROBLEM,
    label: i18n.t("integration.zendesk.health_score.type.problem")
  },
  {
    value: TICKET_TYPE.INCIDENT,
    label: i18n.t("integration.zendesk.health_score.type.incident")
  },
  {
    value: TICKET_TYPE.DOUBT,
    label: i18n.t("integration.zendesk.health_score.type.doubt")
  },
  {
    value: TICKET_TYPE.TASK,
    label: i18n.t("integration.zendesk.health_score.type.task")
  }
];

export const TICKET_PRIORITY_OPTIONS = [
  {
    value: TICKET_PRIORITY.URGENT,
    label: i18n.t("integration.zendesk.health_score.priority.urgent")
  },
  {
    value: TICKET_PRIORITY.HIGH,
    label: i18n.t("integration.zendesk.health_score.priority.high")
  },
  {
    value: TICKET_PRIORITY.NORMAL,
    label: i18n.t("integration.zendesk.health_score.priority.normal")
  },
  {
    value: TICKET_PRIORITY.LOW,
    label: i18n.t("integration.zendesk.health_score.priority.low")
  }
];

export const TICKET_STATUS_OPTIONS = [
  {
    value: TICKET_STATUS.OPEN,
    label: i18n.t("integration.zendesk.health_score.status.open")
  },
  {
    value: TICKET_STATUS.PENDING,
    label: i18n.t("integration.zendesk.health_score.status.pending")
  },
  {
    value: TICKET_STATUS.WAITING,
    label: i18n.t("integration.zendesk.health_score.status.waiting")
  },
  {
    value: TICKET_STATUS.SOLVED,
    label: i18n.t("integration.zendesk.health_score.status.solved")
  },
  {
    value: TICKET_STATUS.CLOSED,
    label: i18n.t("integration.zendesk.health_score.status.closed")
  }
];
